// extracted by mini-css-extract-plugin
export default {"wrapper":"BatchUpdateEdge_wrapper__nvbwS"};